import React from 'react'
import './ClientIssue.css' 

export const ClientIssue = () => {

const issues = [
  { title: "Scattered Investments",
    label: "Let's consolidate your efforts and hard-earned money",
    icon: "fas fa-chart-pie",
    initial: "0+" },
  {
    title: "Too many Financial Goals",
    label: "We'll help you prioritize, plan and put to action",
    icon: "fa-solid fa-bullseye",
    initial: "0+",
  },
  {
    title: "Inflation Stress",
    label: "Inflation hurts? Not investing right, even more!",
    icon: "fa-solid fa-indian-rupee-sign",
    initial: "0+",
  },
  {
    title: "Easy Access to Reports",
    label: "Financial insights & portfolio reports at your fingertips",
    icon: "fa-regular fa-file-lines",
    initial: "0%",
  },
];


  return (
    <section className="wc-client-issue-section">
      <div className="wc-client-issue-container">
        <h2 className="wc-heading-issue">
           {/* <h2 className="wc-ui-multiply-title"> */}
          Stuck with these <span className="wc-ui-gradient-text">financial </span> challenges?
        {/* </h2> */}
        </h2>
        <div className="wc-ui-issue-grid">

        {issues.map((issue, index) => (
          <div key={index} className="wc-client-issue-card">
            <div className="wc-ui-issue-icon">
              <i className={issue.icon}></i>
            </div>
            <h3 className="wc-ui-issue-title">{issue.title}</h3>
            <p className="wc-ui-stat-label">{issue.label}</p>
          </div>
        ))}
      </div>
      </div>
    </section>
  )
}